import { useTranslation } from "react-i18next";
import { NeuButton, NeuCard } from "../../../components/neu/Neu";

// تحذير قبل الحفظ: كل تغيير يُبطل الصوت المخزَّن ويُعيد التوليد على حساب الأرصدة.
export const VoiceSaveConfirm = ({ usage, onCancel, onConfirm, busy }) => {
  const { t } = useTranslation();
  const count = usage?.generated || 0;
  const credits = usage?.credits_next_change_est || 0;

  return (
    <NeuCard className="mt-4 border border-destructive/30" data-testid="voice-save-confirm">
      <p className="text-sm font-bold text-destructive">{t("greeting.confirmTitle")}</p>
      <p className="mt-2 text-xs text-muted-foreground">
        {t("greeting.confirmBody", { count, credits: credits.toLocaleString("en-US") })}
      </p>
      <div className="mt-3 flex gap-2">
        <NeuButton
          variant="primary"
          className="px-4 py-2 text-xs"
          data-testid="voice-save-confirm-yes"
          disabled={busy}
          onClick={onConfirm}
        >
          {t("greeting.confirmYes")}
        </NeuButton>
        <NeuButton className="px-4 py-2 text-xs" data-testid="voice-save-confirm-no" onClick={onCancel}>
          {t("greeting.confirmNo")}
        </NeuButton>
      </div>
    </NeuCard>
  );
};
